import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-image-zoom-page" }
const _hoisted_2 = { class: "pantry-image-zoom-page-area" }
const _hoisted_3 = {
  ref: "image",
  class: "pantry-image-zoom-page-image"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", _hoisted_3, null, 512)
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: 9,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      negativeLabel: _ctx.ERROR_BUTTON_LABEL,
      onNegativeClick: _ctx.closeError
    }, null, 8, ["isShowDialog", "title", "message", "negativeLabel", "onNegativeClick"])
  ]))
}